import * as tslib_1 from "tslib";
import { OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { FcPaginatorComponent } from '@core/components/fc-paginator/fc-paginator.component';
import { Subject } from 'rxjs';
import { debounceTime, filter, switchMap, takeUntil, tap } from 'rxjs/operators';
import { SegmentService } from '../../../services/segment.service';
import { LinkGroupsComponent } from './link-groups/link-groups.component';
var TabGroupsComponent = /** @class */ (function () {
    function TabGroupsComponent(matDialog, segmentService) {
        this.matDialog = matDialog;
        this.segmentService = segmentService;
        this.searchInput = new FormControl('');
        this.page = null;
        this.isSearching = false;
        this.pageSize = 5;
        this.currentPage = 0;
        this.isLoading = true;
        this.isPageChanging = false;
        this.removeSubscriptions = new Subject();
        this.reload = new Subject();
    }
    TabGroupsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.searchInput.valueChanges.pipe(debounceTime(500))
            .subscribe(function () {
            _this.isLoading = true;
            if (_this.paginator) {
                _this.paginator.firstPage();
            }
            else {
                _this.reload.next();
            }
        });
        this.reload.pipe(takeUntil(this.removeSubscriptions), tap(function () { return _this.isLoading = true; }), switchMap(function () { return _this.searchGroups(); }), tap(function () {
            _this.isLoading = false;
        })).subscribe(function (page) {
            _this.page = page;
        });
        this.reload.next();
    };
    TabGroupsComponent.prototype.ngOnChanges = function (changes) {
        if (changes.segment) {
            this.reload.next();
        }
    };
    TabGroupsComponent.prototype.ngOnDestroy = function () {
        this.removeSubscriptions.next();
        this.removeSubscriptions.complete();
    };
    TabGroupsComponent.prototype.openLinkLocationsDialog = function () {
        var _this = this;
        this.matDialog
            .open(LinkGroupsComponent, {
            panelClass: ['dialog-segments'],
            backdropClass: 'backdrop-transparent',
            data: {
                segment: this.segment,
            },
        })
            .beforeClosed()
            .pipe(filter(function (result) { return result && result.reload; }))
            .subscribe(function () {
            _this.reload.next();
        });
    };
    TabGroupsComponent.prototype.searchGroups = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!this.segment.id) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, this.segmentService.listGroups({
                        segmentId: this.segment.id,
                        limit: this.pageSize,
                        offset: this.currentPage * this.pageSize,
                        where: {
                            name_contains: this.searchInput.value,
                            segmentId_in: [this.segment.id]
                        }
                    })];
            });
        });
    };
    TabGroupsComponent.prototype.removeSegmentFroGroup = function (group) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        group['isSaving'] = true;
                        return [4 /*yield*/, this.segmentService.removeSegmentFromGroup([{
                                    groupId: group.id,
                                    segmentId: this.segment.id
                                }])];
                    case 1:
                        _b.sent();
                        _a = this;
                        return [4 /*yield*/, this.searchGroups()];
                    case 2:
                        _a.page = _b.sent();
                        group['isSaving'] = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    TabGroupsComponent.prototype.onPageChange = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.currentPage = event.pageIndex;
                        this.isPageChanging = true;
                        _a = this;
                        return [4 /*yield*/, this.searchGroups()];
                    case 1:
                        _a.page = _b.sent();
                        this.isPageChanging = false;
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return TabGroupsComponent;
}());
export { TabGroupsComponent };
